import { render, staticRenderFns } from "./LeftArrowIcon.vue?vue&type=template&id=31969e0b&"
import script from "./LeftArrowIcon.vue?vue&type=script&lang=ts&"
export * from "./LeftArrowIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports